import '@aarsteinmedia/dotlottie-player-light';

import { checkIfDeviceAllowsEditing, getAppUrl } from '../helpers';

function initPage() {
  document.addEventListener('DOMContentLoaded', _onDOMContentLoaded);

  function _onDOMContentLoaded() {
    if (!checkIfDeviceAllowsEditing()) {
      document.querySelectorAll('a.app-access-button').forEach((e) => {
        e.innerHTML = 'Request Invite';
        e.href = getAppUrl() + '/invite';
      });
      document.querySelectorAll('a[data-mobile-href]').forEach((e) => {
        e.href = e.getAttribute('data-mobile-href');
      });
    }

    _prepareLottieAnimationsOnMobile();
    _cleanUpLottieSVGs();
  }

  function _cleanUpLottieSVGs() {
    try {
      // The following code will remove the transform attribute from the SVG element
      // It causes the Lottie animation to be displayed correctly instead of being blurred because of the 3d transform
      let elements = document.getElementsByTagName('dotlottie-player');
      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('play', (event) => {
          try {
            event.target.shadowRoot.querySelector('svg').style.transform = '';
          } catch (e) {
            console.error('[_cleanUpLottieSVGs] Error while trying to remove the transform attribute from the SVG element', e);
          }
        });
      }
    } catch (e) {
      console.error('[_cleanUpLottieSVGs] Error while trying to clean up Lottie SVGs', e);
    }
  }

  function _prepareLottieAnimationsOnMobile() {
    try {
      // The following code will change the src attribute of the Lottie animation to the src-mobile attribute if the screen width is less than 768px
      // This is done to load a smaller version of the Lottie animation on mobile devices
      if (window.innerWidth < 768) {
        let elements = document.getElementsByTagName('dotlottie-player');
        for (var i = 0; i < elements.length; i++) {
          if (elements[i].hasAttribute('src-mobile')) {
            const src = elements[i].getAttribute('src');
            elements[i].setAttribute('src', elements[i].getAttribute('src-mobile'));
            elements[i].setAttribute('src-desktop', src);
            elements[i].removeAttribute('src-mobile');
            console.debug(
              `[_prepareLottieAnimationsOnMobile] Changed Lottie animation src to src-mobile (${elements[i].getAttribute('id')}): ${src} -> ${elements[i].getAttribute('src')}`,
            );
          }
        }
      }
    } catch (e) {
      console.error('[_prepareLottieAnimationsOnMobile] Error while trying to prepare Lottie animations on mobile', e);
    }
  }
}

export { initPage };
